var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 60,
    viewBox: "0 0 69 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 37V1C69 0.4 68.54 0 67.85 0H1.15C0.46 0 0 0.4 0 1V48C0 48.6 0.46 49 1.15 49H12.65V47H2.3V2H66.7V36H55.2C54.51 36 54.05 36.4 54.05 37V47H28.75V49H55.2C55.545 49 55.775 48.9 56.005 48.7L68.655 37.7C68.77 37.6 68.77 37.5 68.885 37.4V37.3C69 37.2 69 37.1 69 37ZM56.35 38H65.09L60.72 41.8L56.35 45.6V38Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.735 9.7C21.62 9.3 21.16 9 20.7 9C20.24 9 19.78 9.3 19.665 9.7L16.33 18.4C16.215 18.6 16.1 18.8 16.1 19V52V59C16.1 59.6 16.56 60 17.25 60H24.15C24.84 60 25.3 59.6 25.3 59V52V19C25.3 18.8 25.185 18.5 25.07 18.4L21.735 9.7ZM18.4 20H19.55V51H18.4V20ZM21.85 20H23V51H21.85V20ZM20.7 13.2L22.54 18H18.86L20.7 13.2ZM23 58H18.4V53H19.55H21.85H23V58Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.25 6C34.5 6 29.9 10 29.9 15V17H32.2V15C32.2 11.1 35.765 8 40.25 8C44.735 8 48.3 11.1 48.3 15V17H50.6V15C50.6 10 46 6 40.25 6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1 16V14H59.8V16C59.8 19.9 56.235 23 51.75 23C47.265 23 43.7 19.9 43.7 16V14H41.4V16C41.4 21 46 25 51.75 25C57.5 25 62.1 21 62.1 16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8545 33V43C28.8545 43.6 29.3145 44 30.0045 44H41.5045C42.1945 44 42.6545 43.6 42.6545 43V33C42.6545 32.4 42.1945 32 41.5045 32H30.0045C29.3145 32 28.8545 32.4 28.8545 33ZM31.1545 34H40.3545V42H31.1545V34Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.85 35V37H47.15C47.84 37 48.3 36.6 48.3 36V28C48.3 27.4 47.84 27 47.15 27H37.95C37.26 27 36.8 27.4 36.8 28V30H39.1V29H46V35H44.85Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20002 5H6.90002V7H9.20002V5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 5H11.5V7H13.8V5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4 5H16.1V7H18.4V5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 9H11.5V11H13.8V9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20002 9H6.90002V11H9.20002V9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20002 13H6.90002V15H9.20002V13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20002 17H6.90002V19H9.20002V17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20002 21H6.90002V23H9.20002V21Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20002 25H6.90002V27H9.20002V25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20002 29H6.90002V31H9.20002V29Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20002 33H6.90002V35H9.20002V33Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20002 37H6.90002V39H9.20002V37Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20002 41H6.90002V43H9.20002V41Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 60,
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDesign);
export default __webpack_public_path__ + "static/media/ProductDesign.da8b9d8d1f0bdf4e873d4cfaf629b0e0.svg";
export { ForwardRef as ReactComponent };